import React from "react";
import ApiRequest from "./common/restservice";
import { errorToast } from "./common/showtoast";
import PageHeader from "./common/pageheader";

export default class Transactions extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isCompany: true,
      fromDate: "",
      toDate: "",
      tableData: []
    }
  }
  componentDidMount() {
    if (this.props.match.params) {
      this.setState({
        isCompany: this.props.match.params.type !== "Cash"
      })
    }
    this.GetTransactions();
  }
  async GetTransactions() {
    let jsoninput = {
      fromdate: this.state.fromDate,
      todate: this.state.toDate
    }
    let url = this.props.match.params.type !== "Cash" ? "GetCompanyWallet.asp" : "GetCashWallet.asp";
    let res = await ApiRequest(url, "POST", jsoninput, { Authorization: localStorage.getItem("token") });
    console.log(res);
    if (res.status === "error") {
      errorToast(res.message);
      if (res.message === "Session Expired") {
        localStorage.clear();
        this.props.history.push("/login");
      }
      this.setState({
        tableData: []
      })
      return;
    }
    this.setState({
      tableData: res.items
    })
  }
  render() {
    return (
      <div>
        <PageHeader title="Transactions" />

        <div className="row">
          <div className="col-xl-12 col-lg-12 col-md-12">
            <div className="card">
              <div className="card-header">
                <h3 className="card-title text-color-1" style={{ fontWeight: "200", fontSize: "22px" }}>
                  {this.state.isCompany ? "Company Wallet Transactions" : "Passbook"}
                </h3>
              </div>
              <div className="d-md-flex mt-4 mb-2">
                <div className="col-md-4">
                  <div className="form-group">
                    <div className="input-group">
                      <span className="input-group-prepend">
                        <span className="input-group-text">
                          <i className="fe fe-calendar"></i>
                        </span>
                      </span>
                      <input type="date" className="form-control daterange-single" id="start_date" name="start_date" placeholder="From Date" autoComplete="off" onChange={(e) => {
                        this.setState({
                          fromDate: e.target.value
                        })
                      }} value={this.state.fromDate} />
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group">
                    <div className="input-group">
                      <span className="input-group-prepend">
                        <span className="input-group-text">
                          <i className="fe fe-calendar"></i>
                        </span>
                      </span>
                      <input type="date" className="form-control daterange-single" id="end_date" name="end_date" placeholder="To Date" autoComplete="off" onChange={(e) => {
                        this.setState({
                          toDate: e.target.value
                        })
                      }} value={this.state.toDate} />
                    </div>
                  </div>
                </div>
                <div className="col-md-4 text-left">
                  <div className="form-group"><button type="button" className="btn primebtn" onClick={() => this.GetTransactions()}> Search </button></div>
                </div>
              </div>
              <div className="card-body">
                <div className="table-responsive">
                  <table className="table table-vcenter text-nowrap mb-0 table-striped table-bordered border-top" style={{ textAlign: "center" }}>
                    <thead className="">
                      <tr>
                        <th>S.No</th>
                        <th>Date</th>
                        <th>Description</th>
                        <th>Debit</th>
                        <th>Credit</th>
                        <th>Balance</th>
                      </tr>
                    </thead>
                    <tbody>

                      {
                        this.state.tableData.length <= 0 ? <tr>
                          <td colSpan="6">No Details Found</td>
                        </tr> :
                          this.state.tableData.map((item, index) => (
                            <tr key={index}>
                              <td className="tabletd">{(index + 1)}</td>
                              <td>{item.date}</td>
                              <td>{item.Description}</td>
                              <td>{item.Debit}</td>
                              <td>{item.Credit}</td>
                              <td>{item.Balance}</td>
                            </tr>
                          ))
                      }
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}